export default {
    name: 'StafetPayment',
    props: {
        basket: {
            type: Array,
            required: true,
            default: []
        },
        title: {
            type: String,
            required: true,
            default: ''
        },
        inTotalLabel: {
            type: String,
            required: true,
            default: ''
        },
        inTotalPrice: {
            type: String,
            required: true,
            default: 0
        }
    },
    setup() {}
}
